import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { CarHireDepotDetails } from '@shared/shared/interfaces/travel-car-hire.interfaces';
import { ITravelHotelSearchResult } from '@shared/shared/interfaces/travel-hotel.interfaces';
import {
  HotelSearchInitialState,
  MealBasisDefinition,
} from '@shared/store/travel-search/reducers/hotel-search.reducers';
import * as fromActivityDetailsReducer from './activities-details.reducer';
import { ActivitiesDetailState } from './activities-details.reducer';
import * as fromActivitySearchReducer from './activities.reducer';
import { ActivitiesState } from './activities.reducer';
import * as fromCarHireCategoriesReducer from './car-hire-categories.reducers';
import { CarCategoriesState } from './car-hire-categories.reducers';
import * as fromCarHireDetailsReducer from './car-hire-details.reducers';
import * as fromCarSearchReducers from './car-hire-search.reducers';
import * as fromFlightSearchReducer from './flight-search.reducers';
import { FlightSearchState } from './flight-search.reducers';
import * as fromHotelAmenitiesReducer from './hotel-amenities.reducers';
import { HotelAmenitiesState } from './hotel-amenities.reducers';
import * as fromHotelDetailsReducer from './hotel-details.reducers';
import * as fromHotelMealBasisReducer from './hotel-meal-basis.reducers';
import * as fromHotelRoomsReducer from './hotel-room.reducers';
import { HotelRoomResultsState } from './hotel-room.reducers';
import * as fromHotelSearchReducer from './hotel-search.reducers';
import * as fromHotelSuppliers from './hotel-suppliers.reducers';
import * as fromTravelSearchFormReducer from './travel-search-form.reducers';
export interface TravelSearchState {
  carHireSearch: fromCarSearchReducers.CarHireSearchInitialState;
  carHireDetails: CarHireDepotDetails;
  carHireCategories: CarCategoriesState;
  hotelAmenities: HotelAmenitiesState;
  hotelDetails: ITravelHotelSearchResult;
  hotelMealBasis: { [id: string]: string | MealBasisDefinition };
  hotelSuppliers: { [id: string]: boolean };
  hotelSearch: HotelSearchInitialState;
  flightSearch: FlightSearchState;
  travelSearchForm: fromTravelSearchFormReducer.TravelSearchForm;
  hotelRooms: HotelRoomResultsState;
  activitiesSearch: ActivitiesState;
  activitiesDetails: ActivitiesDetailState;
}

export const reducers: ActionReducerMap<TravelSearchState> = {
  carHireSearch: fromCarSearchReducers.reducer,
  carHireDetails: fromCarHireDetailsReducer.reducer,
  carHireCategories: fromCarHireCategoriesReducer.reducer,
  hotelAmenities: fromHotelAmenitiesReducer.reducer,
  hotelDetails: fromHotelDetailsReducer.reducer,
  hotelMealBasis: fromHotelMealBasisReducer.reducer,
  hotelSuppliers: fromHotelSuppliers.reducer,
  hotelSearch: fromHotelSearchReducer.reducer,
  flightSearch: fromFlightSearchReducer.reducer,
  travelSearchForm: fromTravelSearchFormReducer.reducer,
  hotelRooms: fromHotelRoomsReducer.reducer,
  activitiesSearch: fromActivitySearchReducer.reducer,
  activitiesDetails: fromActivityDetailsReducer.reducer,
};

export const getTravelSearchState = createFeatureSelector<TravelSearchState>('travel-search');
